<template>
  <BaseCard
    v-if="unleash.isEnabled('SalonizedPayTerminalTipping')"
    :heading="t('register.salonized_pay.terminal_settings.tipping.heading')"
    :description="t('register.salonized_pay.terminal_settings.tipping.description')"
  >
    <Flex
      direction="column"
      :gap="1"
    >
      <Flex
        v-for="(preset, index) in presets"
        :key="preset.id"
        align="end"
        :gap="0.5"
      >
        <BaseInputPricePercentage
          v-model="preset.amount"
          v-model:type="preset.type"
          :label="t('register.salonized_pay.terminal_settings.tipping.preset_label', { number: index + 1 })"
          v-test="`sp-terminal-settings-tipping-preset-${index}`"
        />
        <BaseButton
          color="inverted"
          icon="delete"
          @click="removePreset(preset.id)"
          v-test="`sp-terminal-settings-tipping-preset-${index}-remove`"
        />
      </Flex>

      <BaseText
        v-if="presets.length < 3"
        iconBefore="plus"
        inline
        @click="addPreset"
        v-test="'sp-terminal-settings-tipping-add'"
      >
        {{ t('register.salonized_pay.terminal_settings.tipping.add_preset') }}
      </BaseText>

      <BaseText
        color="secondary"
        size="s"
      >
        {{ t('register.salonized_pay.terminal_settings.tipping.limit_note') }}
      </BaseText>
      <Flex>
        <BaseAlert
          color="info"
          :text="t('register.salonized_pay.terminal_settings.applies_to_all')"
        />
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { useI18n } from 'vue-i18n';
import unleash from '@/unleash';
import { type TipPreset, TipType } from './types';

const { t } = useI18n();

const presets = defineModel<TipPreset[]>('presets', { required: true });

const addPreset = () => {
  if (presets.value.length < 3) {
    const nextId =
      Math.max(-1, ...presets.value.map((preset) => preset.id)) + 1;
    presets.value.push({ id: nextId, amount: 0, type: TipType.Fixed });
  }
};

const removePreset = (id: number) => {
  presets.value = presets.value.filter((preset) => preset.id !== id);
};
</script>
